<footer class="footer">
  <div class="container footer__container">
    <div class="footer__content">
      <p class="mb-6">
        Service plans and maintenance & support plans are provided by Domestic &
        General Services Limited. Company No. 1970780. Insurance policies are
        provided by Domestic & General Insurance PLC. Company No. 485850.
        Registered Office for both companies: Swan Court, 11 Worple Road,
        Wimbledon, London SW19 4JS. Both companies are registered in England and
        Wales. We are the underwriter of the insurance policies and do not
        provide a personal recommendation of advice. Domestic & General
        Insurance PLC pay their sales agents periodic incentives (such as bonus
        payments) if they meet certain quality and sales targets. All prices
        include all applicable taxes (including IPT). Domestic & General
        Insurance PLC is authorised by the Prudential Regulation Authority and
        regulated by the Financial Conduct Authority and the Prudential
        Regulation Authority (Financial Services Register Number 202111).
      </p>
      <p>
        This site is protected by reCAPTCHA and the Google
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          class="link"
          >Privacy Policy</a
        >
        and
        <a href="https://policies.google.com/terms" target="_blank" class="link"
          >Terms of Service</a
        >
        apply.
      </p>
      <p>&#169; {{ year }} Domestic & General Group Limited</p>
    </div>
    <ul class="footer__list">
      <li class="footer-item">
        <a
          href="{{ links?.terms }}"
          target="_blank"
          class="link"
          (click)="onClick()"
          >Website Terms and Conditions</a
        >
      </li>
      <li class="footer-item">
        <a
          href="{{ links?.privacy }}"
          target="_blank"
          class="link"
          (click)="onClick()"
          >Privacy and Cookies policy</a
        >
      </li>
      <li class="footer-item">
        <a
          href="{{ links?.accessibility }}"
          target="_blank"
          class="link"
          (click)="onClick()"
          >Accessibility policy</a
        >
      </li>
    </ul>
  </div>
</footer>
